import React from 'react';

import { cn } from 'revibe-ui';
import {
  LazyLoadImage,
  LazyLoadImageProps,
} from 'react-lazy-load-image-component';

type Props = {
  alt: string;
  src: string;
  objectFit?: 'cover' | 'contain';
  children?: React.ReactNode;
};

export const Image = ({
  alt,
  src,
  objectFit = 'cover',
  ...props
}: Props & LazyLoadImageProps) => {
  return (
    <LazyLoadImage
      {...props}
      className={cn(
        'box-border h-full w-full object-center',
        objectFit === 'cover' && 'object-cover',
        objectFit === 'contain' && 'object-contain',
        props.className
      )}
      src={src}
      alt={alt}
      placeholder={<div className="h-full w-full bg-gray-50" />}
      effect="opacity"
      wrapperProps={{
        style: {
          display: 'block',
          height: '100%',
        },
      }}
    />
  );
};
